module.exports = __webpack_public_path__ + "static/media/logo-dark.1a587014.png";